import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const STEPS = [
	'Download the template.',
	'Read the instructions on the first sheet: what each column means, which are required, and an example.',
	'On the Users sheet, add one row per person. Email, name and primary broker group id are required. Sales team and authorised rep ids are also required, unless the person is a Folio admin or their broker group is marked on the Broker groups sheet as not needing them. The other columns are optional.',
	'Save the file (keep it as .xlsx).',
	'Choose the file here. Its rows open in a table with any problems outlined: fix them in the table, or delete the rows. Rows with errors must be fixed or deleted before importing.',
	'Import the rows. The import runs in the background: you can leave the page, and you will get a notification when it finishes.',
];

/** The user import page's steps, in plain language, beside the download and upload. */
export const UserImportSteps = () => (
	<Stack spacing={1}>
		<Typography variant='form_label'>How to import users</Typography>
		<Box component='ol' sx={{ m: 0, pl: 3 }}>
			{STEPS.map((step) => (
				<Typography key={step} component='li' sx={{ mb: 1 }}>
					{step}
				</Typography>
			))}
		</Box>
		<Typography variant='body2' color='text.secondary'>
			People who already have a matching Folio user are skipped, not duplicated. A problem
			with one row does not stop the others. One file can have up to 500 people.
		</Typography>
	</Stack>
);
